export default __webpack_public_path__ + "static/media/icon_arrow_right.e1feac15.svg";